import { transport } from '@opengov/transport';

import { AddCommentResponse, BaseCommentsResponse, UserType, Comment, ArgsType, CommentError } from '@opengov/bnp-component-community-widgets';
import { getComments as getCommentsQuery, addComment as addCommentQuery } from '../../graphQL/communityInteractions';

export enum ORDER{
    ASC = "ASC",
    DESC = "DESC"
};
export type FunctionArgsType = {
    commonArgs: ArgsType;
    fetchCommentsArgs: ArgsType;
    addCommentArgs: ArgsType;
    deleteCommentArgs: ArgsType;
};

export const fetchComments = async (args: ArgsType, apiUrl?: string): Promise<BaseCommentsResponse> => {
    const { limit = 10, offset = 0, entityId, topicId, topicType,parentId } = args;
    const storiesCommunityApiUrl = apiUrl
    return await transport
        .url(`${storiesCommunityApiUrl}/api/community-interactions/public/graphql`)
        .json({
            query: getCommentsQuery,
            variables: {
                entityId: entityId,
                limit: limit,
                offset: offset,
                topicId: topicId,
                topicType: topicType,
                parentId: parentId||null,
                orderBy: parentId ? ORDER.ASC : ORDER.DESC
            }
        })
        .post()
        .json()
        .then((result: { data?: { comments?: { comments: Comment[], totalCount: number } } }) => {
            //temp fix for handling anonymous comments
            let comments: Comment[] = result.data?.comments?.comments || [];
            let modifiedComments: Comment[] = [];

            if (comments.length > 0) {
                comments.forEach(comment => {
                    if (comment.createdByUser?.type === UserType.Anonymous) {
                        modifiedComments.push({
                            ...comment, createdByUser: {
                                ...comment?.createdByUser,
                                name: ""
                            }
                        })
                    }
                    else {
                        modifiedComments.push(comment)
                    }
                })
            }

            return {
                comments: modifiedComments || [],
                totalCount: result.data?.comments?.totalCount || 0
            }
        })
        .catch((error: unknown) => {
            const errorMessage = error instanceof Error ? error.message : String(error);
            throw new Error(errorMessage || 'Failed to fetch comments');
        });
}

export const addComment = async (args: ArgsType, apiUrl?: string): Promise<AddCommentResponse> => {
    const storiesCommunityApiUrl = apiUrl
    const { email, entityId, name, parentId, text, topicId, topicType, type,id } = args;
    return await transport
        .url(`${storiesCommunityApiUrl}/api/community-interactions/public/graphql`)
        .json({
            query: addCommentQuery,
            variables: {
                email: email,
                entityId: entityId,
                name: name,
                parentId: parentId,
                text: text,
                topicId: topicId,
                topicType: topicType,
                userType: type,
                authUserId: id||null
            }
        })
        .post()
        .json()
        .then((result: { data?: { postComment?: { commentId: string, createdAt: string, entityId: string, errors: CommentError[], success: boolean, text: string, topicId: string, topicType: string, userId: string } } }) => {
            const { commentId, createdAt, entityId, errors, success, text, topicId, topicType, userId } = result.data?.postComment || {};
            return {
                commentId: commentId || '',
                createdAt: createdAt || '',
                entityId: entityId || '',
                errors: errors || [],
                success: success || false,
                text: text || '',
                topicId: topicId || '',
                topicType: topicType || '',
                userId: userId || '',
                createdByUser: {
                    id: result.data?.postComment?.userId || '',
                    name:
                        type == UserType.EntityAdmin || type == UserType.PublicUser
                            ? (args.name as string)
                            : UserType.Anonymous,
                    type: type as UserType,
                },
                replyCount: 0
            }
        })
        .catch((error: unknown) => {
            const errorMessage = error instanceof Error ? error.message : String(error);
            throw new Error(errorMessage || 'Failed to add comment');
        });
}



